import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import DetailedServices from './pages/DetailedServices';
import Blog from './pages/Blog'; 
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Privacy from './components/Privacy'; // Yeh import add karein
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            
            {/* Dynamic Service Detail Page */}
            <Route path="/services/:id" element={<DetailedServices />} />

            {/* Blog Pages */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            
            {/* Contact Page */}
            <Route path="/contact" element={<Contact />} />

            {/* Privacy Policy Page (Naya Route) */}
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
<WhatsAppFloat/>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;